import './App.css';
import './custom.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import ArAboutMe from './pages/ArAboutMe';
import NotFoundPage from './pages/NotFoundPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Blog from './pages/Blog';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import Blog from './pages/Blog';
import ContactPage from './pages/ContactPage';


const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'aboutme', element: <ArAboutMe /> },
      { path: 'blog', element: <BlogList /> },
      { path: 'blog/:slug', element: <BlogPost /> },
      { path: 'contact', element: <ContactPage /> },
    ]
  },
  {
    path: '*', element: <NotFoundPage /> 
  },
]);

function App() {
  return (
    <>
    <ToastContainer />
    <RouterProvider router={router}></RouterProvider>
    </>
  );
}

export default App;
